import WResultsInvestment from './WResultsInvestment'

export default WResultsInvestment
